import type { CMSAssetItem } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL, CMS_ASSET_DETAILS_KEY } from '../constants';

const getAssetDetails = (assetType: string, assetId: string): Promise<CMSAssetItem> => {
  // need to add a timestamp to avoid caching
  // when a user return from a preview page we want to make sure we get the latest metrics
  const params = new URLSearchParams();
  const unixTimestamp = Date.now().toString();
  params.append('timestamp', unixTimestamp);
  const paramsStr = params.toString() ? `?${params.toString()}` : '';
  return FetchPromise.get(`${CMS_API_ROOT_URL}/${assetType}/${assetId}${paramsStr}`);
};

export const useGetAssetDetails = (assetType: string, assetId: string) =>
  useQuery<CMSAssetItem, JQuery.jqXHR>([CMS_ASSET_DETAILS_KEY, assetType?.toUpperCase(), assetId], () =>
    getAssetDetails(assetType, assetId),
  );
